export function getNoOfUnitsText(number: number) {
  if (number === 1) return "1 sztuka";

  if (number > 4) return number + " sztuk";
  if (number > 1) return number + " sztuki";
}
